// Google Analytics 4 Integration
class Analytics {
  constructor() {
    this.measurementId = 'G-XXXXXXXXXX'; // Replace with your actual GA4 Measurement ID
    this.isInitialized = false;
  }

  // Initialize Google Analytics
  init() {
    if (this.isInitialized || typeof window === 'undefined') {
      return;
    }

    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', this.measurementId, {
      page_title: document.title,
      page_location: window.location.href,
      send_page_view: true
    });

    this.isInitialized = true;
    console.log('✅ Google Analytics initialized');
  }

  // Track page views
  trackPageView(pageName, pagePath) {
    if (!this.isInitialized || typeof window === 'undefined') {
      return;
    }

    window.gtag('config', this.measurementId, {
      page_title: pageName,
      page_location: window.location.href,
      page_path: pagePath
    });

    console.log(`📊 Page view tracked: ${pageName}`);
  }

  // Track events
  trackEvent(eventName, parameters = {}) {
    if (!this.isInitialized || typeof window === 'undefined') {
      return;
    }

    window.gtag('event', eventName, {
      event_category: parameters.category || 'engagement',
      event_label: parameters.label || '',
      value: parameters.value || 0,
      ...parameters
    });

    console.log(`📊 Event tracked: ${eventName}`, parameters);
  }

  // Track user registration
  trackRegistration(userEmail, userRole) {
    this.trackEvent('sign_up', {
      method: 'email',
      user_type: userRole,
      email: userEmail
    });
  }

  // Track user login
  trackLogin(userEmail, userRole) {
    this.trackEvent('login', {
      method: 'email',
      user_type: userRole,
      email: userEmail
    });
  }

  // Track service card clicks
  trackServiceCardClick(serviceName) {
    this.trackEvent('service_card_click', {
      service_name: serviceName,
      category: 'engagement'
    });
  }

  // Track pricing page views
  trackPricingView() {
    this.trackEvent('view_pricing', {
      category: 'engagement'
    });
  }

  // Track contact form submissions
  trackContactFormSubmit() {
    this.trackEvent('contact_form_submit', {
      category: 'lead_generation'
    });
  }

  // Track service requirements submission
  trackServiceRequirementSubmit(serviceType) {
    this.trackEvent('service_requirement_submit', {
      service_type: serviceType,
      category: 'lead_generation'
    });
  }

  // Track cart interactions
  trackAddToCart(serviceName, price) {
    this.trackEvent('add_to_cart', {
      item_name: serviceName,
      value: price,
      currency: 'INR',
      category: 'ecommerce'
    });
  }

  // Track checkout initiation
  trackBeginCheckout(totalValue) {
    this.trackEvent('begin_checkout', {
      value: totalValue,
      currency: 'INR',
      category: 'ecommerce'
    });
  }

  // Track scroll depth
  trackScrollDepth(percentage) {
    this.trackEvent('scroll_depth', {
      scroll_percentage: percentage,
      category: 'engagement'
    });
  }

  // Track time on page
  trackTimeOnPage(timeInSeconds) {
    this.trackEvent('time_on_page', {
      time_seconds: timeInSeconds,
      category: 'engagement'
    });
  }

  // Track custom conversions
  trackConversion(conversionType, value = 0) {
    this.trackEvent('conversion', {
      conversion_type: conversionType,
      value: value,
      currency: 'INR',
      category: 'conversion'
    });
  }
}

// Create singleton instance
const analytics = new Analytics();

export default analytics;
